import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { SubsectionTitle } from 'Components/Blocks/Titles'
import { Button, Text } from 'Components/UI'

import { LANDING_CONTENT_PX } from 'Constants/Landing'

import Points from './Points'
import { Container, Content } from './styles'

type Props = {
  secondary?: boolean
  onAction?: () => void
}

function EmajinCorporateMembershipPackagesSection({
  secondary,
  onAction,
}: Props) {
  return (
    <SectionContainer>
      <Container secondary={secondary}>
        <AppearingWrapper centered>
          <Content px={LANDING_CONTENT_PX} py={[44, 44, 80, 80, 100]}>
            <SubsectionTitle
              centered
              maxWidth={800}
              subtitle="Take your business networking from the boardroom to the fairway with Emajin Golf."
              title="Emajin Corporate Membership Packages"
            />

            <Text body center maxWidth={800} medium my={8} screen18>
              Our membership-based golf networking group has been built with a
              key focus on helping you grow your business and nurturing your
              team while playing the finest courses around the country.
            </Text>

            <Points />

            <Button large mt={12} onClick={onAction}>
              Join Us Today
            </Button>
          </Content>
        </AppearingWrapper>
      </Container>
    </SectionContainer>
  )
}

export default EmajinCorporateMembershipPackagesSection
